"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fastlyCompressionQuery = exports.initialDictionary = exports.initialState = void 0;

var _pim = require("../../../lib/pim");

var _svg = require("./svg");

var initialState = {
  pepDetailsComponentName: 'pep-product-details.component:not(.custom)',
  pepListComponentName: 'pep-product-list.component:not(.custom)',
  pepAccListComponentName: 'pep-accessories-list.component:not(.custom)',
  favoriteProductsName: 'favoriteProducts',
  accessoryParametr: '&accessory',
  professionalKey: 'Professional',
  productList: null,
  selectedFilters: [],
  activeProducts: [],
  loading: true,
  labels: {},
  pepFilters: null,
  selectedProduct: null,
  relatedProducts: null,
  favoriteProducts: {},
  constansFromPim: {
    headline: _pim.PIMConstants.BRAND.HEADLINE,
    body: _pim.PIMConstants.BRAND.BODY
  },
  currentSliderImg: null,
  dictionary: null,
  openFilters: false,
  isMobile: null
};
exports.initialState = initialState;
var initialDictionary = {
  instrumentListPath: '/hearing-aid-users/pep-test/product-list',
  productDetailsPath: '/hearing-aid-users/pep-test/product-details?productId=',
  accessoriesListPath: '/hearing-aid-users/pep-test/accessories-list',
  buyPath: '/hearing-aid-users/hcl',
  buyButton: 'Where to buy',
  readMore: 'Read more',
  'Release Date': 'Release Date',
  Type: 'Type',
  'Hearing Loss': 'Hearing Loss',
  'Bluetooth vs telecoil': 'Supports either Bluetooth or telecoil',
  'Battery Style': 'Battery Style',
  'Phone Compatibiility': 'Phone Compatibiility',
  Rechargeable: 'Rechargeable',
  'Not Rechargeable': 'Not Rechargeable',
  'Expected Battery Life': 'Expected Battery Life',
  'Hearing Aids': 'Hearing Aids',
  Accessories: 'Accessories',
  'Battery Type': 'Battery Type',
  'Hearing Aid List Marketing Headline': 'Hearing Aid List Marketing headline',
  'Hearing Aid List Marketing Body': 'Hearing Aid List Marketing body',
  'Accessories List Marketing Headline': 'Accessories List Marketing headline',
  'Accessories List Marketing Body': 'Accessories List Marketing body',
  BTE: 'Behind the ear',
  ITE: 'In the ear',
  hours: 'hours',
  filters: 'Filters',
  mobileBreakpoint: 767,
  see: 'See',
  reset: 'Reset',
  products: 'products',
  clear: 'Clear filters',
  // compatibility
  compatibilityGuide: 'Compatibility guide',
  phoneCompatibility: 'Compatibility with smartphones',
  compatibilityDescription: 'with a smart device, you simply need to ensure that the smart device is running one of the following operating systems:',
  toUseYourLabel: 'To use your',
  ios: 'iOS',
  android: 'Android',
  laterLabel: 'or later',
  moreInformation: 'For more information, go to our',
  appleDevices: 'Apple devices',
  androidDevices: 'Android devices',
  relatedProducts: 'Related products',
  backToHearingAids: 'BACK TO HEARING AIDS',
  backToAccessoriesList: 'BACK TO ACCESSORIES',
  compatibilityGuideLink: '/hearing-aid-users/support/faq/compatibility',
  modalTitle: 'Why is my device not on the list?',
  modalTextBeforeOsVersion: 'Generally, Oticon strives to be compatible with as many devices as possible. If your device is not on this list, it’s because we haven’t tested it. However, it is still likely to work with our hearing aids and apps if it meets the following criteria:',
  modalTextAfterOsVersion: 'Even if that’s not the case, your device might still work, but may not offer full functionality. Visit your app store to download a version of the app compatible to your device.</br>We always recommend using the latest version of the operating system.</br>If you cannot use our apps, Oticon ConnectClip makes it possible to control your hearing aids without touching them - and to stream sound from your Bluetooth devices.',
  //
  apps: 'Apps',
  relatedAccessories: 'Accessories',
  bluetooth: 'Compatibility',
  marketingMaterials: 'Support &<br>Instructions',
  OticonON: '254659',
  RemoteCare: '90039',
  // favorite-products
  print: 'Print',
  senEmail: 'sendEmail',
  savePdf: 'Save as PDF',
  youHave: 'You have',
  savedProduct: 'saved products in your list',
  benefits: 'Benefits',
  //guide
  recommendedProducts: 'Recommended hearing aids',
  oticonRecommends: 'Your recommendation',
  result: 'Result',
  oticonRecommendsDescription: 'Here is our recommendation for you, based on the answers you’ve given.',
  next: 'Next',
  previous: 'Previous',
  testAgain: 'Take the test again',
  findHearingCentreLabel: 'Find a hearing centre',
  productGuideHeadline: 'Choosing the right hearing aid',
  productGuideSubheadline: 'By answering a few quick questions we\'ll create a list of recommended hearing aids',
  recommendedHeadlineFirst: 'styles out of',
  recommendedHeadlineSecond: 'styles recommended',
  tabDictionary: {
    apps: _svg.appSVG,
    relatedAccessories: _svg.accessoriesSVG,
    bluetooth: _svg.compatibilitySVG,
    marketingMaterials: _svg.supportSVG
  },
  settingsParam: {
    params: {
      isReady: false,
      CatalogID: '',
      Culture: '',
      CatalogStatus: '',
      ProductsIds: []
    },
    token: {}
  },
  icons: {
    "default": 'e866',
    pdf: 'e915',
    img: 'e89c',
    video: 'e91a',
    embed: 'e91a',
    external: 'ea40',
    zip: 'e90b',
    doc: 'e912',
    ppt: 'e906',
    searchIcon: 'e607'
  },
  documents: {
    PDF: 'application/pdf',
    MP4: 'video/mp4',
    JPEG: 'image/jpeg',
    PNG: 'image/png',
    BMP: 'image/bmp',
    EMBED: 'application/embed',
    EXTERNAL: 'application/external',
    ZIP: 'application/x-zip-compressed',
    DOC: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PPT: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
  },
  // apps info
  appStoreImg: '-/media/84DBD2997E6246CA94576B078B0EDFAD.ashx',
  googlePlayImg: '-/media/0732EB7A2E2E4601B2B717A2A4B7BADB.ashx',
  oticonOnAppStoreLink: 'https://apps.apple.com/app/id980191174',
  oticonOnGooglePlayLink: 'https://play.google.com/store/apps/details?id=com.oticon.remotecontrol',
  remoteCareAppStoreLink: 'https://apps.apple.com/app/id1178623811',
  remoteCareGooglePlayLink: 'https://play.google.com/store/apps/details?id=com.oticon.remoteassistance.Oticon',
  companionAppStoreLink: 'https://apps.apple.com/app/id1597064213',
  companionGooglePlayLink: 'https://play.google.com/store/apps/details?id=com.oticon.app'
};
exports.initialDictionary = initialDictionary;
var fastlyCompressionQuery = {
  general: 'format=pjpg&auto=webp&quality=80&sharpen=a5,r2,t0',
  productOverview: 'width=250',
  mainSlider: 'height=600',
  thumbnailsSlider: 'width=75',
  appsTab: 'width=220',
  accessoriesTab: 'width=220',
  lifestyleSection: 'width=800',
  productGuideThumbnails: 'width=115',
  compatibilityGuideOverview: 'width=280'
};
exports.fastlyCompressionQuery = fastlyCompressionQuery;